import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'settledWrapper',
    'settledDisabledIndicator', // hidden field for passing information about disabled state due to HTTP statelessness
    'settledInput',
  ];
  static values = {
    hiddenInputChangeable: Boolean, // if form allows edition of settled flag
  };

  /*
    At start if settled is set, but checkbox is disabled browser will send hidden field with value of "0".
    We need to send "1" for disabled field, so we change value of hidden input in this situation.
  */
  initialize() {
    if (
      !this.hasSettledInputTarget ||
      !this.hasHiddenInputChangeableValue ||
      !this.hiddenInputChangeableValue
    ) {
      return;
    }

    if (
      this.settledInputTarget.checked &&
      this.settledInputTarget.getAttribute('disabled') === 'disabled'
    ) {
      this.setHiddenValue(true);
    }
  }

  setHiddenValue(checked) {
    let hidden_input =
      this.settledWrapperTarget.querySelector('input[type=hidden]');

    if (checked) {
      hidden_input.value = '1';
    } else {
      hidden_input.value = '0';
    }

    hidden_input.removeAttribute('disabled');
  }

  amountChanged() {
    this.removeDisabledClass(this.settledWrapperTarget);
    this.removeDisabledClass(
      this.settledWrapperTarget.querySelector('.label label'),
    );
    this.enableAndUncheck(this.settledInputTarget);
    this.settledDisabledIndicatorTarget.value = null;
    this.setHiddenValue(false);
  }

  enableAndUncheck(input) {
    this.removeDisabledClass(input);
    input.removeAttribute('disabled');
    input.removeAttribute('checked');
    input.checked = false;
  }

  removeDisabledClass(element) {
    element.classList.remove('disabled');
  }
}
